export const PDFData = [
    {
        inputName: 'loanType',
        inputOptions: [
            { value: 'WC', label: 'Working Capital/CAPEX/OPEX' },
            { value: 'CF', label: 'Contract Financing' },
            { value: 'IF', label: 'Invoice Financing' },
            { value: 'MCP', label: 'Micro Credit Prihatin' },
        ],
    },
    {
        inputName: 'bizEntityType',
        inputOptions: [
            {
                value: 'SP',
                label: 'Sole Proprietorship',
            },
            {
                value: 'PN',
                label: 'Partnership',
            },
            {
                value: 'LLP',
                label: 'Limited Liability Partnership',
            },
            {
                value: 'SDNBHD',
                label: 'Sendirian Berhad (Sdn Bhd)',
            },
            {
                value: 'PROFBODIES',
                label: 'Professional Bodies',
            },
            {
                value: 'IND',
                label: 'Individual (Business License with Local Council)',
            },
        ],
    },
    {
        inputName: 'bizSector',
        inputOptions: [
            {
                value: '01',
                label: 'Electricity, Gas, & Water',
            },
            {
                value: '02',
                label: 'Agriculture, Forestry & Fishing',
            },
            {
                value: '03',
                label: 'Mining & Quarrying',
            },
            {
                value: '04',
                label: 'Manufacturing',
            },
            {
                value: '05',
                label: 'Transport, Storage, & Communication',
            },
            {
                value: '06',
                label: 'Financing, Insurance, Real Estate & Business Service',
            },
            {
                value: '07',
                label: 'Construction',
            },
            {
                value: '08',
                label: 'Wholesale & Retail Trade & Restaurants & Hotels',
            },
            {
                value: '09',
                label: 'Other Services',
            },
            {
                value: '10',
                label: 'Tourism',
            },
        ],
    },
    {
        inputName: 'bizOpYear',
        inputOptions: [
            { value: '0.5', label: 'Less than 6 months' },
            { value: '0.6', label: '6 months to less than 1 year' },
            { value: '1', label: '1 year to less than 2 years' },
            { value: '2', label: '2 years to less than 3 years' },
            { value: '3', label: '3 years to less than 4 years' },
            { value: '4', label: '4 years and above' },
        ],
    },
    {
        inputName: 'profitabilityRecentYear',
        inputOptions: [
            {
                value: null,
                label: 'Non Profitable',
                filterParentValue: ['1', '2', '3', '4'],
            },
            {
                value: '11',
                label: 'Profitable for the latest 1 year',
                filterParentValue: ['1', '2', '3', '4'],
            },
            {
                value: '22',
                label: 'Profitable for the latest 2 years',
                filterParentValue: ['2', '3', '4'],
            },
            {
                value: '33',
                label: 'Profitable for the latest 3 years',
                filterParentValue: ['3', '4'],
            },
        ],
    },
];
